var websiteRegex = /^(https?:\/\/)?([a-z0-9][a-z0-9\\-]*\.)+[a-z0-9][a-z0-9\\-]*([\/?#].*)?$/i;
var validateWebsite = function (value) {
    if (value === null || value === undefined || value === '')
        return true;
    return websiteRegex.test(value);
};
export default validateWebsite;
